import { Select } from '@/shared/components/ui'
import { useT } from '@/shared/i18n'
import { cn } from '@/shared/lib/cn'

import { useCompanies } from '../api'

export interface CompanySwitcherProps {
  /** `null` = todas las empresas. */
  value: string | null
  onChange: (companyId: string | null) => void
  className?: string
}

/**
 * Conmutador de empresa con opcion "Todas".
 *
 * "Todas" es el DEFAULT y no una opcion mas: el problema que resuelve esta app
 * es ver el portafolio completo de un vistazo; filtrar por empresa es el caso
 * particular, no el general.
 */
export function CompanySwitcher({ value, onChange, className }: CompanySwitcherProps) {
  const t = useT()
  const { data: companies = [], isPending } = useCompanies()

  return (
    <Select
      aria-label={t('common.label.company')}
      disabled={isPending}
      className={cn('w-auto min-w-[150px]', className)}
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value === '' ? null : event.target.value)}
    >
      <option value="">{t('companies.switcher.all')}</option>
      {companies.map((company) => (
        <option key={company.id} value={company.id}>
          {company.name}
        </option>
      ))}
    </Select>
  )
}
